import constants from '@/config/constants';
import { isEmpty } from '@/common/validators';
import store from '@/store/index.js';
import { getUserAge } from '@/common/userInfoUtils';
import { Auth } from 'aws-amplify';

/**
 * EQチャット 開始ステップ番号の取得
 * @return 開始ステップ番号
 */
export function getEQStartStep() {
  // それぞれ50％の確率でどちらかのステップ番号を返却する
  return constants.INTRO_EQ_STEP_START_LIST[Math.floor(Math.random() * constants.INTRO_EQ_STEP_START_LIST.length)];
}

/**
 * EQチャット 渡されたステップ番号がシナリオBか判定する
 * @param {String} step ステップ番号
 * @return シナリオBの場合はtrue、それ以外の場合はfalseを返却する
 */
export function checkSenarioBStep(step) {
  // Eqシナリオステップ番号（シナリオB）の正規表現
  const eqSenarioBStepRegexp = new RegExp(
    '^' +
      constants.STEP_FIRST_CHAR +
      constants.STEP_CONNECT_CHAR +
      constants.STEP_INTRO_EQ_CHAR +
      constants.STEP_CONNECT_CHAR +
      constants.STEP_EQ_B_CHAR +
      constants.STEP_CONNECT_CHAR +
      '[0-9]{3}'
  );

  // EQイントロシナリオBステップ番号（シナリオB）の正規表現
  const introEqSenarioBStepRegexp = new RegExp(
    '^' +
      constants.STEP_FIRST_CHAR +
      constants.STEP_CONNECT_CHAR +
      constants.STEP_INTRO_CHAR +
      constants.STEP_CONNECT_CHAR +
      constants.STEP_INTRO_EQ_CHAR +
      constants.STEP_CONNECT_CHAR +
      constants.STEP_EQ_B_CHAR +
      constants.STEP_CONNECT_CHAR +
      '[0-9]{3}'
  );

  // 次ステップ番号の先頭がEQシナリオステップ番号（シナリオB）の場合
  if (!isEmpty(step.match(eqSenarioBStepRegexp))) {
    return true;
  }

  // 次ステップ番号の先頭がEQイントロシナリオステップ番号（シナリオB）の場合
  if (!isEmpty(step.match(introEqSenarioBStepRegexp))) {
    return true;
  }

  return false;
}

/**
 * 製品版チャット 開始ステップ番号の取得
 * @return 開始ステップ番号
 */
export async function getStartStep() {
  // ログイン状態をチェック
  let login;
  await Auth.currentAuthenticatedUser()
    .then(() => {
      login = true;
    })
    .catch(() => {
      login = false;
    });

  if (login) {
    // ログインユーザの場合
    // ストアから生まれ年を取得
    const birthYear = store.getters['user/birth_year'];
    // 年齢を計算
    const userAge = getUserAge(birthYear);

    if (userAge.age < 20) {
      // 20歳未満の場合は、U-19用開始ステップ番号を返す
      return constants.INTRO_STEP_U19_START;
    } else {
      // 20歳以上の場合は、通常の開始ステップ番号を返す
      return constants.INTRO_STEP_START;
    }
  } else {
    // ノーログインユーザの場合
    // ストアから年代を取得
    const ageRange = store.getters['user/age_range'];
    if (ageRange === '10歳代') {
      // 10歳代の場合は、U-19用開始ステップ番号を返す
      return constants.INTRO_STEP_U19_START;
    } else {
      // それ以外の年代の場合は、通常の開始ステップ番号を返す
      return constants.INTRO_STEP_START;
    }
  }
}
